import { Vehicle } from '@otw/models/inventory'

export function calculateVehicleLtv(listPrice: number | null | undefined, grayBookRetailPrice: number | null): number | null {
  if (!listPrice || !grayBookRetailPrice || grayBookRetailPrice <= 0) return null
  return (listPrice / grayBookRetailPrice) * 100
}

export function calculateVehicleProfit(vehicle: Vehicle, listPrice: number | null | undefined): number | null {
  if (!listPrice || !vehicle.seller_asking_price) return null

  const rawCustomerShipping = vehicle.shipping?.customer_shipping_cost
  const rawOurShipping = vehicle.shipping?.our_shipping_cost
  const customerShipping =
    rawCustomerShipping != null && !Number.isNaN(Number(rawCustomerShipping))
      ? Number(rawCustomerShipping)
      : 0
  const ourShipping =
    rawOurShipping != null && !Number.isNaN(Number(rawOurShipping)) ? Number(rawOurShipping) : 0
  const shippingProfit = customerShipping - ourShipping

  const gross = listPrice - vehicle.seller_asking_price + shippingProfit
  return gross - (vehicle.repair_cost || 0)
}

export function parseListPrice(raw: string | undefined): number | null {
  if (raw === undefined || raw.trim() === '') return null
  const value = Number(raw)
  if (Number.isNaN(value) || value < 0) return null
  return value
}
